export const SET_COMMITMENTS = (state, payload) => {
    state.commitments = payload;
};

export const SET_OFFERING_BOOK = (state, payload) => {
    state.offeringBook = payload;
};

export const SET_EXCHANGE_LISTINGS = (state, payload) => {
    state.exchangeListings = payload;
    state.exchangeListingsLoaded = true;
};

export const SET_EXCHANGE_RAISING = (state, payload) => {
    state.exchangeRaising = payload;
};

export const SET_MARKET_ACTIVITY = (state, payload) => {
    state.marketActivity = payload;
};

export const SET_MARKET_ACTIVITY_LOADING = (state, payload) => {
    state.marketActivityLoading = payload;
};

export const SET_PORTFOLIO_PERFORMANCE = (state, payload) => {
    state.portfolioPerformance = payload;
};

export const SET_PORTFOLIO_PERFORMANCE_LOADING = (state, payload) => {
    state.portfolioPerformanceLoading = payload;
};

export const SET_TOKEN = (state, payload) => {
    state.token = payload;
};
export const SET_TOKEN_REQUESTS = (state, payload) => {
    state.tokenRequests = payload;
};
export const SET_DEALS = (state, payload) => {
    state.deals = payload;
};
export const SET_DEALS_PAGES = (state, payload) => {
    state.dealsPageInfo = payload;
};
export const SET_TOKEN_REQUESTS_PAGES = (state, payload) => {
    state.pageInfo = payload;
};
export const SET_DEAL_MEMBERS = (state, payload) => {
    state.dealMembers = payload;
};
export const SET_TOKEN_TRANSACTIONS = (state, payload) => {
    state.tokenTransactions = payload;
};
export const SET_TOTAL_TRANSACTION = (state, payload) => {
    state.totalTransactions = payload;
};

export const SET_PAGE = (state, payload) => {
    state.page = payload;
};

export const SET_PAGES = (state, payload) => {
    state.pages = payload;
};

export const SET_DEAL_INVESTORS = (state, payload) => {
    state.dealInvestors = payload;
};

export const SET_MEMBER_QUERY = (state, payload) => {
    state.members = payload;
};
export const SET_DEALROOM_MEMBERS = (state, payload) => {
    state.dealroomMembers = payload;
};
export const SET_DEALROOM_WAITLIST = (state, payload) => {
    state.dealroomWaitlist = payload;
};
export const SET_ALL_DEALROOM_MEMBERS = (state, payload) => {
    state.allDealRoomMembers = payload;
};

// Mutations from investor-base
export const SET_INVESTOR_TOKENS = (state, payload) => {
    state.userTokens = payload;
};

export const SET_UNLIMITED_INVESTOR_TOKENS = (state, payload) => {
    state.unlimitedUserTokens = payload;
};

export const SET_USER_DEAL_ROOM = (state, payload) => {
    state.userDealRooms = payload;
};

export const SET_USER_PRIVATE_TOKENS = (state, payload) => {
    state.privateTokens = payload;
};
export const SET_RAISING_TOKENS = (state, payload) => {
    state.raisingTokens = payload;
};
export const SET_RAISED_TOKENS = (state, payload) => {
    state.raisedTokens = payload;
};

export const SET_ORDER_BOOK = (state, payload) => {
    state.orderBook = payload;
};

export const SET_ORDER_PAGE = (state, payload) => {
    state.orderBookPage = payload;
};

export const SET_ORDER_PAGES = (state, payload) => {
    state.orderBookPages = payload;
};

export const SET_PUBLIC_TOKENS = (state, payload) => {
    state.publicTokens = payload;
};

export const SET_TOKEN_INFO = (state, payload) => {
    state.tokenInfo = payload;
};

export const SET_ASSET_INFO = (state, payload) => {
    state.assetInfo = payload;
};

export const SET_RAISING_PAGES = (state, payload) => {
    state.raisingPages = payload;
};

export const SET_RAISING_PAGE = (state, payload) => {
    state.raisingPage = payload;
};

export const SET_RAISED_PAGES = (state, payload) => {
    state.raisedPages = payload;
};

export const SET_RAISED_PAGE = (state, payload) => {
    state.raisedPage = payload;
};

export const SET_INVESTOR_TOKEN_PAGES = (state, payload) => {
    state.investorTokenPages = payload;
};

export const SET_INVESTOR_TOKEN_PAGE = (state, payload) => {
    state.investorTokenPage = payload;
};

export const SET_TOKEN_BALANCE = (state, payload) => {
    state.tokenBalance = payload;
};

export const SET_TOKEN_PAYOUT_DETAILS = (state, payload) => {
    state.tokenPayoutDetails = payload;
};

export const SET_DEAL_ROOM_INFO = (state, payload) => {
    state.dealRoomInfo = payload;
};

export const SET_TOKEN_UPDATE = (state, payload) => {
    state.tokenUpdates = payload;
};

export const SET_TOKEN_UPDATE_PAGE = (state, payload) => {
    state.tokenUpdatePage = payload;
};

export const SET_TOKEN_UPDATE_PAGES = (state, payload) => {
    state.tokenUpdatePages = payload;
};

export const SET_DEAL_SUBSCRIPTION_STATUS = (state, payload) => {
    state.subscriptionStatus = payload;
};

export const SET_SUBSCRIPTION_PLANS = (state, payload) => {
    state.subscriptionPlans = payload;
};

export const SET_BUY_ORDER_BOOK = (state, payload) => {
    state.buyOrderBook = payload;
};

export const SET_SELL_ORDER_BOOK = (state, payload) => {
    state.sellOrderBook = payload;
};
export const SET_ORG_INFO = (state, payload) => {
    state.orgInfo = payload;
};
export const SET_WHY_WE_LISTED = (state, payload) => {
    state.whyWeListed = payload;
};
export const SET_CERTIFICATE_INFO = (state, payload) => {
    state.certificateInfo = payload;
};
export const SET_BADGE_INFO = (state, payload) => {
    state.badgeInfo = payload;
};
export const SET_MEMBERSHIP_STATUS = (state, payload) => {
    state.membershipStatus = payload;
};
export const SET_EXCHANGE_STATS = (state, payload) => {
    state.exchangeStats = payload;
};
